import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { setupAxios } from 'utils/auth-helper'
import { AuthProvider } from 'context/auth'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-tooltip/dist/react-tooltip.css'
import 'cropperjs/dist/cropper.css'
import 'react-date-picker/dist/DatePicker.css'
import 'react-datetime-picker/dist/DateTimePicker.css'
import 'react-time-picker/dist/TimePicker.css'
import 'react-clock/dist/Clock.css'
import 'react-calendar/dist/Calendar.css'
import './index.css'
import { OperatorProvider } from 'context/operator'

setupAxios()
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <OperatorProvider>
        <App />
      </OperatorProvider>
    </AuthProvider>
    <ToastContainer />
  </BrowserRouter>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
